var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"spinner-container flex--center"},[_c('b-spinner',{staticClass:"modalSpinner",attrs:{"label":"Loading..."}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }